import {
	addUpdatePincodeApi,
	downloadPincodeApi,
	talukRequestGetApi,
} from './config.api';

export const configApis = [
	talukRequestGetApi,
	addUpdatePincodeApi,
	downloadPincodeApi,
];
